<template>
  <div class="waajo-chat-media" :class="'is-' + mediaType">
    <template v-if="mediaType === 'image'">
      <a
        v-if="mediaUrl && !loadFailed"
        class="waajo-media-image"
        :href="mediaUrl"
        target="_blank"
        rel="noopener"
        title="Buka gambar"
        @click.prevent="$emit('open', mediaUrl)"
      >
        <img
          :src="mediaUrl"
          :alt="caption || 'Gambar'"
          loading="lazy"
          @error="loadFailed = true"
        />
        <span v-if="row.media_size" class="waajo-media-size">
          {{ row.media_size }}
        </span>
      </a>
      <a
        v-else
        class="waajo-media-fallback"
        :href="mediaUrl || undefined"
        target="_blank"
        rel="noopener"
      >
        <i class="fa fa-picture-o"></i>
        Gambar tidak dapat dimuat
        <span v-if="mediaUrl">Buka media</span>
      </a>
    </template>

    <template v-else-if="mediaType === 'video'">
      <video
        v-if="mediaUrl && !loadFailed"
        class="waajo-media-video"
        :src="mediaUrl"
        controls
        preload="none"
        @error="loadFailed = true"
      ></video>
      <a
        v-else
        class="waajo-media-fallback"
        :href="mediaUrl || undefined"
        target="_blank"
        rel="noopener"
      >
        <i class="fa fa-film"></i>
        Video tidak dapat diputar
        <span v-if="mediaUrl">Buka media</span>
      </a>
    </template>

    <template v-else-if="mediaType === 'document' || mediaType === 'file'">
      <a
        v-if="mediaUrl"
        class="waajo-media-file"
        :href="mediaUrl"
        target="_blank"
        rel="noopener"
        :download="fileName || undefined"
      >
        <span class="waajo-media-file-icon">
          <i :class="fileIcon"></i>
        </span>
        <span class="waajo-media-file-copy">
          <strong>{{ fileName || caption || "Lampiran" }}</strong>
          <small>
            {{ fileExtension || "Berkas" }}
            <template v-if="row.media_size"> • {{ row.media_size }}</template>
          </small>
        </span>
        <i class="fa fa-download waajo-media-download" aria-hidden="true"></i>
      </a>
      <span v-else class="waajo-media-fallback is-muted">
        <i class="fa fa-paperclip"></i>
        Media tidak tersedia
      </span>
    </template>

    <template v-else>
      <a
        v-if="mediaUrl"
        class="waajo-media-fallback"
        :href="mediaUrl"
        target="_blank"
        rel="noopener"
      >
        <i class="fa fa-paperclip"></i>
        Buka media
      </a>
      <span v-else class="waajo-media-fallback is-muted">
        <i class="fa fa-paperclip"></i>
        Media tidak tersedia
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "chat-media",
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadFailed: false
    };
  },
  computed: {
    mediaType() {
      return String(this.row.message_type || "").toLowerCase();
    },
    mediaUrl() {
      const value = this.row && this.row.message_media;
      return typeof value === "string" ? value.trim() : "";
    },
    caption() {
      return String(this.row.message || "").trim();
    },
    fileName() {
      if (!this.mediaUrl || this.mediaUrl.indexOf("data:") === 0) {
        return "";
      }

      const withoutQuery = this.mediaUrl.split("?")[0].split("#")[0];
      const name = withoutQuery.split("/").pop() || "";
      try {
        return decodeURIComponent(name);
      } catch (error) {
        return name;
      }
    },
    fileExtension() {
      const name = this.fileName;
      if (!name || name.indexOf(".") === -1) {
        return this.mediaType;
      }
      return name.split(".").pop().toUpperCase();
    },
    fileIcon() {
      const ext = String(this.fileExtension || "").toLowerCase();
      if (ext === "pdf") return "fa fa-file-pdf-o";
      if (["xls", "xlsx", "csv"].indexOf(ext) !== -1) return "fa fa-file-excel-o";
      if (["doc", "docx", "rtf"].indexOf(ext) !== -1) return "fa fa-file-word-o";
      if (["ppt", "pptx"].indexOf(ext) !== -1) return "fa fa-file-powerpoint-o";
      if (["zip", "rar", "7z"].indexOf(ext) !== -1) return "fa fa-file-archive-o";
      return "fa fa-file-o";
    }
  }
};
</script>

<style scoped>
.waajo-chat-media {
  max-width: 100%;
}

.waajo-media-image {
  position: relative;
  display: block;
  width: 220px;
  max-width: 100%;
  overflow: hidden;
  border-radius: 10px;
  background: #eef2f7;
}

.waajo-media-image img {
  display: block;
  width: 100%;
  max-height: 280px;
  object-fit: cover;
}

.waajo-media-size {
  position: absolute;
  right: 7px;
  bottom: 6px;
  padding: 2px 6px;
  color: #ffffff;
  background: rgba(15, 23, 42, 0.58);
  border-radius: 5px;
  font-size: 8px;
  line-height: 1.3;
}

.waajo-media-video {
  display: block;
  width: 280px;
  max-width: 100%;
  max-height: 280px;
  background: #101828;
  border-radius: 10px;
}

.waajo-media-file {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 250px;
  max-width: 100%;
  padding: 8px 9px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  text-decoration: none;
}

.waajo-media-file:hover {
  color: #b36b00;
  border-color: #f6d49b;
  text-decoration: none;
}

.waajo-media-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  color: #b36b00;
  background: #fff7e8;
  border-radius: 8px;
  font-size: 15px;
}

.waajo-media-file-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.waajo-media-file-copy strong {
  overflow: hidden;
  color: inherit;
  font-size: 10px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-media-file-copy small {
  color: #98a2b3;
  font-size: 8px;
}

.waajo-media-download {
  flex: 0 0 auto;
  color: #98a2b3;
  font-size: 12px;
}

.waajo-media-fallback {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  color: #667085;
  background: #f8fafc;
  border: 1px dashed #d8e1eb;
  border-radius: 8px;
  font-size: 10px;
  text-decoration: none;
}

.waajo-media-fallback span {
  color: #b36b00;
  font-weight: 700;
}

.waajo-media-fallback.is-muted {
  color: #98a2b3;
}
</style>



// WEBPACK FOOTER //
// src/views/omni/components/ChatMedia.vue